// Convert Persian digits to English digits
const convertPersianToEnglish = (persianNumber) => {
    const persianDigits = '۰۱۲۳۴۵۶۷۸۹';
    const englishDigits = '0123456789';
    
    if (typeof persianNumber === 'string') {
        return persianNumber.split('').map(char => {
            const index = persianDigits.indexOf(char);
            return index !== -1 ? englishDigits[index] : char;
        }).join('');
    }
    return persianNumber;
};

const convertHourToPersianDigit = (number) => {
    // Convert Persian digits to English if needed
    const englishNumber = convertPersianToEnglish(number);
    const numericValue = parseInt(englishNumber, 10);
    
    // Check if conversion was successful
    if (isNaN(numericValue)) {
        console.warn('Invalid number format:', number);
        return '۰:۰۰';
    }
    
    const hours = Math.floor(numericValue / 60);
    const minutes = numericValue % 60; 
    const persianHours = (hours < 10 ? '۰' : '') + hours.toLocaleString('fa-IR');
    const persianMinutes = (minutes < 10 ? '۰' : '') + minutes.toLocaleString('fa-IR');

    return persianHours + ':' + persianMinutes;
}

export { convertHourToPersianDigit, convertPersianToEnglish }